import { render } from "./CampaignName.vue?vue&type=template&id=2bbd58a8&scoped=true"
import script from "./CampaignName.vue?vue&type=script&lang=js"
export * from "./CampaignName.vue?vue&type=script&lang=js"

import "./CampaignName.vue?vue&type=style&index=0&id=2bbd58a8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbd58a8"]])

export default __exports__